import React from 'react';
import IFormatterEntry from 'common/types/IFormatterEntry';
import WorkerStateLabelBadge from 'components/WorkerStateLabelBadge';
// import IDatatableEntry from 'common/types/IDatatableEntry'

const WorkerStateLabel = ({ entry }: IFormatterEntry) => <WorkerStateLabelBadge state={entry as string} />;

export default WorkerStateLabel;
